import { render, staticRenderFns } from "./teamEmployees.vue?vue&type=template&id=610163a7&scoped=true&"
import script from "./teamEmployees.vue?vue&type=script&lang=js&"
export * from "./teamEmployees.vue?vue&type=script&lang=js&"
import style0 from "./teamEmployees.vue?vue&type=style&index=0&id=610163a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610163a7",
  null
  
)

export default component.exports